<template>
  <div class="container">
    <div class="footer">
      Copyright © 2025 杭州蓝昌科技有限公司 All Right Reserved.
      备案号：浙ICP备14032474号-1, 技术支持：杭州蓝昌科技
    </div>
    <div class="tabMenu">
      <div class="menuLeft">
        <img :src="logo" alt="" />
        <span>杭州蓝昌科技有限公司</span>
      </div>
      <div class="menuright">
        <span
          class="menuItem"
          :class="{ actiev: currentIndex == 0 }"
          @click="goToPage('0')"
          >官网首页</span
        >
        <span style="color: white">•</span>
        <span
          :class="{ actiev: currentIndex == 1 }"
          class="menuItem"
          @click="goToPage('1')"
          >关于我们</span
        >
        <span style="color: white">•</span>
        <span
          :class="{ actiev: currentIndex == 2 }"
          class="menuItem"
          @click="goToPage('2')"
          >产品服务</span
        >
        <span style="color: white">•</span>
        <span
          :class="{ actiev: currentIndex == 3 }"
          class="menuItem"
          @click="goToPage('3')"
          >数据服务</span
        >
        <span style="color: white">•</span>
        <span
          :class="{ actiev: currentIndex == 4 }"
          class="menuItem"
          @click="goToPage('4')"
          >战略合作</span
        >
        <span style="color: white">•</span>
        <span
          :class="{ actiev: currentIndex == 5 }"
          class="menuItem"
          @click="goToPage('5')"
          >联系我们</span
        >
        <!-- <div @click="copyToClipboard('13347709060')" class="menuItem_img">
          <img :src="phonePng" alt="" />
        </div> -->
        <div @click="copyToClipboard('hr@launchang.com')" class="menuItem_img">
          <img :src="emailPng" alt="" />
        </div>
      </div>
    </div>
    <div class="slider" :style="sliderStyle">
      <div
        id="home"
        class="img_box"
        ref="div0"
        :style="{ backgroundImage: `url(${require('@/assets/1.png')})` }"
      >
        <div class="div0_mid">
          <div class="mid_imgBox">
            <img :src="lunanchangkeji" alt="" />
          </div>
          <div class="englishLan">
            <span>LAUNCHANG</span><span>SENSING</span><span>THE</span><span>WORLD</span>
          </div>
          <div class="div0_content">蓝昌科技致力于从采集、维护到应用的全链条数据服务</div>
          <div class="img_titleBox">
            <img :src="title_left" alt="" />
            <span class="fangkuai"></span>
            <img :src="title_right" alt="" />
          </div>
          <!-- <div class="div0_button_box">
          
          </div> -->
        </div>
      </div>
      <div class="xiala">
        <img :src="xiala" alt="" />
        <div class="xiala_line">下滑了解更多</div>
      </div>
      <div
        class="img_box"
        id="aboutUs"
        ref="div1"
        :style="{ backgroundImage: `url(${require('@/assets/2.png')})` }"
      >
        <div class="div1_mid">
          <div class="titleBox">
            <div class="titleBox_chinese">公司介绍</div>
            <div class="titleBox_english"><span>COMPANY</span><span>PROFILE</span></div>
          </div>
          <div class="div1_midc_content">
            <span>杭州蓝昌科技有限公司，成立于2014年，是一家应用“</span>
            <span class="blod">物联网+大数据</span>
            <span>”技术为</span>
            <span class="blod">政府、科研、企业、公众</span>
            <span
              >等提供自然资源环境大数据应用的整体解决方案服务商、设备制造商。为了深入开展数据服务的研究和应用，公司与相关科研院所、业务单位建立长期战略合作关系。通过在智能海洋监测设备、大数据等研发技术的持续投入，为涉海企业、政府单位提供国产化自主研发的海洋观测设备、信息系统、海洋技术服务等解决方案。</span
            >
          </div>
          <div class="div1_button_box">
            <!-- <div class="div1_button" @click="jump('1')">了解详情</div> -->
          </div>
        </div>
      </div>
      <div
        class="img_box"
        id="products"
        ref="div2"
        :style="{ backgroundImage: `url(${require('@/assets/3.png')})` }"
      >
        <div class="div2_mid">
          <div class="div2_left">
            <div class="titleBox">
              <div class="titleBox_chinese">主营业务</div>
              <div class="titleBox_english"><span>MAIN</span><span>BUSINESS</span></div>
            </div>
            <div class="div1_midc_content">
              <span>公司为自然资源、气象、水文系统近</span>
              <span class="blod">百</span>
              <span>家单位建设和维护近</span>
              <span class="blod">千</span>
              <span
                >套海洋观测系统（海洋站、浮标、志愿船）。开发多套海洋数据管理、全国海洋观测数据传输系统和预报软件系统，建设了机房数据中心等，在</span
              >
              <span class="blod">自然环境大数据传感技术应用研究、防灾减灾、生态资源</span>
              <span>保护方面做了大量有效的探索和创新。</span>
            </div>
            <div class="div1_button_box">
              <!-- <div class="div1_button" @click="jump('2')">了解详情</div> -->
            </div>
          </div>
          <div class="div2_right">
            <img :src="goujia" alt="" />
          </div>
          <div class="productBox">
            <div class="imgBox">
              <div
                v-for="(item, index) in productDetail"
                :key="index"
                class="productBox_item"
                @click="getDetail(item.id)"
              >
                <img :src="item.imageUrl" alt="" />
                <p>{{ item.name }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="img_box"
        id="dataService"
        ref="div3"
        :style="{ backgroundImage: `url(${require('@/assets/4.png')})` }"
      >
        <div class="div8_mid">
          <div class="titleBox">
            <div class="titleBox_chinese">数据服务</div>
            <div class="titleBox_english"><span>DATA</span> <span>SERVICE</span></div>
          </div>
          <div class="div1_midc_content">
            <span
              >数据中心以关系型数据、图库、分布式对象文件系统等存储通过固定式观测设备、移动式观测设备</span
            >
            <span class="blod">
              浮标观测资料、船舶观测资料、argo观测资料、台风观测资料、潜标观测资料、glide观测资料</span
            >
            <span
              >等回传的等实况观测资以及经过自主收集、处理、质量控制、偏差订正、融合同化的气象海洋卫星遥感观测资料和在分析资料等，通过一体化定制接口提供数据浏览、数据定制化下载、数据订阅等数据服务。</span
            >
            <!-- <span class="blod">国家高新技术企业、软件企业、杭州市青蓝企业认定，</span>
            <span>拥有专利与软件著作权等知识产权多项，具有</span>
            <span class="blod"
              >质量管理体系、环境管理体系、信息安全管理体系、信息技术服务管理体系、武器装备质量管理体系</span
            >
            <span> 等认证证书。</span> -->
          </div>
          <div class="imgDataBox">
            <img :src="mapPng" alt="" />
          </div>
        </div>
      </div>
      <div
        class="img_box"
        ref="div4"
        id="partners"
        :style="{ backgroundImage: `url(${require('@/assets/5.png')})` }"
      >
        <div class="div4_mid">
          <div class="titleBox">
            <div class="titleBox_chinese">战略合作</div>
            <div class="titleBox_english">
              <span>STRATEGIC</span><span>COOPERATION</span>
            </div>
          </div>
          <div class="div4_mid_content">
            <span>
              为了深入开展数据服务的研究和应用，公司与多家政府机构、顶尖科研院所及行业领军企业建立深度战略合作，通过资源整合与技术创新，打造数据服务标杆项目。依托前沿技术实力与全流程服务体系，已成功落地多个高端数字化智能系统，为国家的海洋事业发展持续增砖添瓦，以</span
            >
            <span class="blod"> 专业、高效、可靠</span>
            <span>的服务品质赢得合作伙伴高度认可，树立行业口碑典范。</span>
          </div>
          <div class="partner_list">
            <div class="partner_title">政府单位</div>
            <div class="partner_img">
              <div v-for="(image, index) in zfArr" :key="index" class="partner_img_box">
                <img :src="image" alt="" />
              </div>
            </div>
          </div>
          <div class="partner_list">
            <div class="partner_title">高校合作</div>
            <div class="partner_img">
              <div
                v-for="(image, index) in schoolArr"
                :key="index"
                class="partner_img_box"
              >
                <img :src="image" alt="" />
              </div>
            </div>
          </div>
          <!-- <ul class="div4_mid_ul">
            <li>
              <img :src="li1" alt="" /><span>科研单位： 自然资源部第四海洋研究所</span>
            </li>
            <li><img :src="li2" alt="" /><span>业务公司： 中远海运</span></li>
            <li>
              <img :src="li3" alt="" /><span>预报机构： 国家海洋局南海预报中心</span>
            </li>
            <li>
              <img :src="li4" alt="" /><span
                >信息计量： 南海信息中心、东海标准计量中心</span
              >
            </li>
          </ul> -->
          <!-- <div class="div4_mid_img">
          <div v-for="(image, index) in paiArr" :key="index" class="pai_image">
            <img :src="image" alt="" />
          </div>
          </div> -->
        </div>
      </div>
      <div
        class="img_box"
        ref="div5"
        id="contactUs"
        :style="{ backgroundImage: `url(${require('@/assets/6.png')})` }"
      >
        <div class="div5_mid">
          <div class="contact_one">联系我们</div>
          <div class="contact_two">CONTACT US</div>
          <div class="contact_three">
            <div class="contact_three_item">
              <img :src="contactPone" alt="" /> <span>hr@launchang.com</span>
            </div>
            <div class="contact_three_item">
              <img :src="contactAdress" alt="" />
              <span>浙江省杭州经济技术开发区6号大街260号10幢4层</span>
            </div>
          </div>
          <div id="map" class="mapBox"></div>
        </div>
      </div>
    </div>
    <el-dialog
      :destroy-on-close="true"
      :title="poduct.name"
      :visible.sync="Flag"
      width="60%"
      top="23vh"
      :close-on-click-modal="false"
    >
      <div class="product_detail_box">
        <img class="product_img" :src="poduct.imageUrl" alt="" />
        <div class="product_content">
        <div>{{ poduct.description }}</div>
        <div style="margin-top: 20px;" v-if="poduct.coreFunctions"><span style="font-weight: bolder;color:#fff">核心功能：</span> <span>{{ poduct.coreFunctions }}</span></div>
        <div style="margin-top: 20px;" v-if="poduct.basicParameters"><span style="font-weight: bolder;color:#fff">基本参数：</span> <span>{{ poduct.basicParameters }}</span></div>
        <div style="margin-top: 20px;" v-if="poduct.elements"><span style="font-weight: bolder;color:#fff">观测要素：</span> <span>{{ poduct.elements }}</span></div>
        <div style="margin-top: 20px;" v-if="poduct.power"><span style="font-weight: bolder;color:#fff">供电模式：</span> <span>{{ poduct.power }}</span></div>
        <div style="margin-top: 20px;" v-if="poduct.technicalParameter"><div style="font-weight: bolder;color:#fff">技术参数：</div>
        <ul style="padding-left: 30px;margin-top: 10px;">
        <li v-for="(item, index) in poduct.technicalParameter" :key="index" >{{ item }}</li>
        </ul>
        </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import "animate.css";
export default {
  name: "Home",

  data() {
    return {
      poduct: {
        id: 1,
        name: "海洋站多路智能通信模块",
        imageUrl: require("@/assets/product1.png"),
        description:
          "海洋站多路智能通信模块针对海洋观测系统现有常用的水文、气象采集器获取的实时观测数据传输问题,设计实现多种通信链路冗余传输技术、数据通信握手技术、双向数据核查自动获取的数据补全技术，支持北斗三代、中国星网、亚太网络等先进网络通信技术更好地保障海洋信息的有效传输，实现高速率、高保障率的数据传输目标。该产品已获取相关发明专利。",
      },
      Flag: false,
      currentIndex: 0,
      isAnimating: false,
      animationQueue: [],
      // 每个区块的进入和退出动画配置
      animations: [
        { enter: "animate__fadeInUp", exit: "animate__slideOutRight" },
        { enter: "animate__slideInRight", exit: "animate__slideOutLeft" },
        { enter: "animate__zoomIn", exit: "animate__zoomOut" },
        { enter: "animate__flipInX", exit: "animate__flipOutX" },
        { enter: "animate__lightSpeedInRight", exit: "animate__lightSpeedOutLeft" },
        { enter: "animate__rotateIn", exit: "animate__rotateOut" },
      ],
      zfArr: [
        require("@/assets/zf1.png"),
        require("@/assets/zf2.png"),
        require("@/assets/zf3.png"),
        require("@/assets/zf4.png"),
      ],
      schoolArr: [
        require("@/assets/school1.png"),
        require("@/assets/school2.png"),
        require("@/assets/school3.jpg"),
        require("@/assets/school4.png"),
      ],
      logo: require("@/assets/logo.png"),
      phonePng: require("@/assets/phone.png"),
      emailPng: require("@/assets/email.png"),
      title_left: require("@/assets/title_left.png"),
      title_right: require("@/assets/title_right.png"),
      lunanchangkeji: require("@/assets/luanchang.png"),
      xiala: require("@/assets/xiala.png"),
      goujia: require("@/assets/goujia.png"),
      contactPone: require("@/assets/pone.png"),
      contactAdress: require("@/assets/adress.png"),
      productDetail: [
        {
          id: 8,
          name: "北斗三代定位预警终端",
          imageUrl: require("@/assets/product11.png"),
          description:"北斗三代定位预警终端是融合北斗三号卫星定位系统与通信技术的综合设备，主要用于船舶航行安全监控，包括智能防碰撞系统、航线偏离预警等，并可用于海上浮标定位以及浮标移位报警等领域，实现远程监控与应急响应。",
          coreFunctions:"主要实现高精度定位、实时数据传输及应急预警功能。",
          basicParameters:"通过壳体一体化封装工艺，采用不锈钢、IP68材质，可耐受-40℃~85℃极端温度及盐雾腐蚀环境；",
          power:'采用太阳能和内置蓄电池双模供电，低功耗设计，可长期工作免维护。      '

        },
        {
          id: 9,
          name: "浮子式潮位计",
          imageUrl: require("@/assets/product12.png"),
          description:"浮子式潮位计是一种通过浮子机械传动记录水位变化的监测设备，其核心组件包括浮子、配重悬索、水位轮及编码器。主要用于长期测量水库、河流、湖泊、坝体测压管等的水位。",
          coreFunctions:"浮子随水位升降带动水位轮旋转，驱动编码器输出格雷码信号，实现水位变化的精确记录。",
          basicParameters:"整体外壳尺寸为290mm×330mm×215mm（长×宽×高），水位轮周长为32厘米，外壳采用防水的铝合金外壳和IP68防护等级设计。",
          technicalParameter:['测量范围：量程为0~10m；','接口类型：支持电源、RS232、RS485等接口，支持温盐仪接口；','通信方式：支持4G网络、DTU 、北斗等通信模式。']
        },
          {
          id: 1,
          name: "海洋站多路智能通信模块",
          imageUrl: require("@/assets/product1.png"),
          description:
            "海洋站多路智能通信模块针对海洋观测系统现有常用的水文、气象采集器获取的实时观测数据传输问题,设计实现多种通信链路冗余传输技术、数据通信握手技术、双向数据核查自动获取的数据补全技术，支持北斗三代、中国星网、亚太网络等先进网络通信技术更好地保障海洋信息的有效传输，实现高速率、高保障率的数据传输目标。该产品已获取相关发明专利。",
        },
        {
          id: 10,
          name: "海洋站通用型数据采集器",
          imageUrl: require("@/assets/product13.png"),
          description:"海洋站通用型数据采集器主要兼容现有多种传感器数据，实现硬件接口与软件接口通用化，实现海洋环境监测的自动化采集与处理。能够在无人值守的情况下长期连续工作，实现7*24小时全天候不间断精准监测。主要应用于海洋环境综合监测等领域，可无缝衔接现有海洋站观测业务。",
          coreFunctions:"支持多参数同步测量，实时数据传输及存储，具备适应复杂海洋环境能力。",
          basicParameters:"外壳尺寸为240mm×160mm×80mm（长×宽×高），外壳采用防水的铝合金外壳和IP68防护等级设计。",
          technicalParameter:['采集类型：用于采集风速、风向、气压、气温、湿度、雨量、潮位、能见度、水温、盐度；','接口类型：兼容各种传感器接口，包括电流、电压、开关量、RS485、RS232、通信、电源等接口；','通信方式：支持4G网络、DTU、卫星等通信模式。']
        },
        {
          id: 11,
          name: "1米波浪谱浮标",
          imageUrl: require("@/assets/product14.png"),
          description:"1米波浪谱浮标（LC-M型）是一种用于监测海洋波浪参数的监测设备，适用于海洋气象监测、海洋动力环境研究、环境保护及灾害预警等领域，支持北斗/铱星/4G等多种通讯模式。",
          coreFunctions:"实时监测目标海域的波高、波周期、波向、波浪谱、涌浪、方位等参数，同时可获取表层水温数据。",
          basicParameters:"该浮标体为圆球型不锈钢材质，直径＜0.8m，采用一体式结构，下连锚泊装置。",
          elements:'波高，波周期，波向，波浪能量及方向谱，涌浪高度，涌浪周期，涌浪方向。'
        },
        {
          id: 12,
          name: "3米多参数水质浮标",
          imageUrl: require("@/assets/product15.png"),
           description:"3米多参数水质浮标（LC-M3型）是一种用于实时监测海洋/水域环境参数的浮动观测平台，适用于海洋环境保护、灾害预警、海洋资源管理等领域，支持4G/北斗/铱星等多种通讯模式。",
          coreFunctions:"集成波浪、水温、水质（如PH、溶解氧、叶绿素等）及气象参数（风速、气压等）的检测功能，支持多维度环境数据采集。",
          basicParameters:"浮标体为圆盘型直径为3米，整体以上柱下锥的外形以及上轻下重的重心布置，使得平台具有很好的稳性和随波性",
          elements:'波高，波周期，波向，气象，海流，多参数水质以及其它水质参数等。'
        },
        {
          id: 13,
          name: "6米海洋观测浮标",
          imageUrl: require("@/assets/product16.png"),
          description:"6米海洋观测浮标（LC-M6型）是一种用于海洋环境监测的多功能设备，适用于海洋环境实时监测、灾害预警及长期数据采集等领域，支持4G/北斗/铱星等多种通讯模式 。",
          coreFunctions:"集成气象、水文、生态监测功能，支持多维度数据采集。",
          basicParameters:"直径6米、型深不大于2.2米、高度不大于8.5米，钢质圆盘型浮体，由标体、桅筒和顶平台组成，含独立水密浮力舱和仪器舱‌",
          elements:'波高，波周期，波向，气象，海流，多参数水质以及其它水质参数等。'
        },
         {
          id: 2,
          name: "10米海洋观测浮标",
          imageUrl: require("@/assets/product3.png"),
          description:
            "10米海洋观测浮标集综合海洋环境监测与智能控制于一体，可精准获取完整波浪真值数据（波高、波周期、波向、波数），并每小时采集风速、风向真值及其他气象参数，支持4G/北斗/铱星等多种通讯模式",
          coreFunctions:"提供高精度、完整的波浪、气象、水文、海流真值数据，并每小时近实时回传观测数据，具备远程控制灵活性，并拥有面向未来的水质监测扩展能力",
          basicParameters:"直径10米，依赖蓄电池供电，具备电压监控能力，支持远程指令控制，具备多重安全监控系统",
          elements:'波高，波周期，波向，气象，海流，多参数水质以及其它水质参数等。'
        },
        
        {
          id: 3,
          name: "表层漂流浮标",
          imageUrl: require("@/assets/product4.png"),
          description:
            "表层漂流浮标搭载智能诊断系统，通过上电自检实时判定设备状态与性能，支持远程参数配置及功能测试。浮标采用北斗/GPS双模卫星定位，精准追踪漂流轨迹与实时位置。在预设程序控制下，内置北斗/铱星通信模块可自动将定位数据及表层水温等关键信息回传至岸基系统。水温测量通过表面嵌入式传感器+高精度采集电路实现，确保海表温度数据准确可靠。本浮标集动态监控、卫星通信、环境感知于一体，为海洋动力研究和环境监测提供高效移动观测平台。",
          coreFunctions:"通过安装于主浮体内部的北斗设备或铱星设备将定位信息和测得的水温等信息发送至数据接收系统",
          basicParameters:"由主浮体和浮标水帆组成，主浮采用高强度聚乙烯材料制成，浮标水帆采用高强度尼龙材料制成，具备良好的抗风浪能力",
          technicalParameter:['观测类型：主要测量表层水温数据；','通讯方式：支持4G/北斗/铱星等多种通讯模式。']
        },
       
        {
          id: 4,
          name: "海洋水文气象监测仪系统",
          imageUrl: require("@/assets/product5.png"),
          description:
            "系统带固态存储，主要用于潮位、风速、风向、温湿度、气压、雨量、水温、盐度的观测，基础设施建设符合《海洋自动观测点建设技术要求》，设备符合《海洋站水文气象观测设备与系统集成通用技术要求》。系统的技术设计符合HY/T 059-2002《海洋站自动化观测通用技术要求》的规定，数据处理的方法、生成的文件内容和遵循的通讯协议符合《海滨观测规范》（GB/T 14914-2006）和我国当前正在业务运行的海洋数据传输网的要求。环境性能符合海洋行业标准《海洋仪器基本环境试验方法》（HY016—92），试验方法、验收规则、标志、包装、运输和贮存要求符合GB/T 13972-2010《海洋水文仪器通用技术条件》。",
          coreFunctions:"实时观测潮位、风速、风向、温湿度、气压、雨量、水温、盐度等核心水文气象参数。独特支持同时接入浮子式验潮仪和雷达式潮位仪，接收双份潮位数据，实现互为备份与故障时自动切换，极大提升潮位观测的可靠性与连续性",
          technicalParameter:['传输能力：可同时在≥3个不同性质（如：4G + 北斗 + 以太网）的网络上传输数据，实现通信负载均衡与多重备份。','通信方式： 4G移动网络、北斗短报文/卫星通信、铱星卫星通信',"系统可靠性： 通过潮位双传感器冗余和通信多网络并行，显著提升系统整体可靠性。"]
        },
        {
          id: 5,
          name: "海床基观测",
          imageUrl: require("@/assets/product6.png"),
          description:
            "海床基观测系统具备实时水下全景监控能力，采用抗腐蚀强化框架结构，为多类传感器提供超稳定支撑平台，确保在复杂海况下持续获取高精度、长时序观测数据，为海洋环境评估、生态研究和灾害预警提供可靠的深海原位监测解决方案。",
          coreFunctions:"持续获取并回传高精度、长时序的海洋环境全要素观测数据，包括油浓度、水温、盐度、浊度、PH、溶解氧、叶绿素、蓝绿藻及ADCP流速剖面等，为海洋环境评估、生态研究和灾害预警提供可靠的深海原位监测解决方案",
          basicParameters:"采用抗腐蚀强化框架结构，具备极端环境耐受性与高频次数据采集能力，提供超稳定支撑平台，确保在复杂海况下持续获取高精度、长时序观测数据",
          technicalParameter:['观测能力： 实时水下全景监控；高精度、长时序数据获取','环境适应性：具备极端环境（深海、复杂海况）耐受性。','数据频率： 每小时完成一次全要素数据采集与回传。']
        },
        {
          id: 6,
          name: "志愿船观测",
          imageUrl: require("@/assets/product7.png"),
          description:
            "船舶测报系统是集成海洋气象与水文数据的实时观测、存储、传输、分析、展示于一体的现代海洋移动观测设备。船舶测报仪实时观测的数据类型有：真风速、真风向、海平面气压、气温、相对湿度、雨量、水温、盐度、皮温以及其它船舶实时状态数据：航速、航向、经度、纬度、方位、合成风速、合成风向、供电电压等。我司所设计的船舶测报仪各项功能与指标符合《志愿船自动测报仪》（HY/T 144-2011）、《船舶气象仪》（JJG876-1994）、《船舶海洋水文气象辅助测报规范》（GB/T 17838-1999 GB/T 17838-2012 ）的要求。",
          coreFunction:"实时采集并记录船舶状态数据（航速、航向、经度、纬度、方位、合成风速、合成风向、供电电压）, 利用4G无线网络、北斗、铱星、海事卫星和船载通讯等多种通讯手段，将数据实时/准实时传输至监测中心, 可通过4G或卫星接收监测中心发布的各项预警报信息",
          basicParameters:"64GB 大容量本地存储器、4G/北斗/铱星等通讯方式，支持实时/准实时数据传输，可进行数据处理，并生成文件，并支持数据传输至监测中心",
          technicalParameter:['数据采集频率： 每秒1次（原始采样）','数据处理： 先进CPU处理器进行实时滤波与数据整合','通讯接口： 支持4G、北斗、铱星、海事卫星、船载通讯多种卫星/无线通讯协议']
        },
          {
          id: 14,
          name: "生态监测站",
          imageUrl: require("@/assets/product17.png"),
          description:"生态监测站是用于实时监测水体质量及生态环境的设施。主要对监测水域的物理、化学及生物学参数进行连续检测。应用于水污染防治、水质预警及生态补偿机制、水资源管理决策等领域。",
          coreFunctions:"配备多参数测定仪和智能传感器，采用自动化采集与传输技术，结合生物监测与水文参数同步分析，为水资源管理提供决策依据",
          basicParameters:"：主要监测多参数水质、高锰酸盐指数、氨氮、总磷、总氮、硝酸盐、亚硝酸盐、磷酸盐、硅酸盐、水中油及风速风向、气温气压等关键指标。",
        },
        {
          id: 7,
          name: "深海Argo业务化应用系统",
          imageUrl: require("@/assets/product10.png"),
          description:
            "深海Argo业务化应用平台系统紧紧围绕“深海Argo”和“业务化应用”两大主题，积极打造集深海Argo源数据“智能化读取、定量化分析、专业化服务”为一体的业务化应用平台，立足为海洋经济建设服务、为海洋管理服务、为政府决策服务、为社会民生服务，为海洋产业发展提供支持。2023年，开展深海Argo业务化应用平台系统项目的建设，搭建系统基础框架，开发Argo源数据处理、管理和可视化展示功能模块。",
          coreFunctions:"数据库建设、数据处理分系统、数据筛选分系统、Argo浮标详细信息分系统、点位图制作分析",
        }
      ],
      mapPng: require("@/assets/map.png"),
    };
  },

  computed: {
    // 计算滑动模块的样式，包括位置和过渡动画
    sliderStyle() {
      return {
        transform: `translateY(-${this.currentIndex * 100}vh)`,
        transition: "transform 0.8s cubic-bezier(0.4, 0, 0.2, 1)",
      };
    },
  },

  mounted() {
    this.initMap();
    // 监听鼠标滚轮事件，用于切换图片
    window.addEventListener("wheel", this.handleWheel, { passive: false });
  },

  beforeDestroy() {
    // 在组件销毁前移除事件监听，防止内存泄漏
    window.removeEventListener("wheel", this.handleWheel);
  },

  methods: {
    initMap() {
      // 创建地图实例
      const map = new window.AMap.Map("map", {
        center: [120.3740551, 30.3038754], // 初始地图中心点（经纬度）
        zoom: 15, // 初始缩放级别
      });

      // 阻止地图缩放时事件冒泡
      const mapContainer = document.getElementById("map");
      if (mapContainer) {
        mapContainer.addEventListener(
          "wheel",
          function (e) {
            e.stopPropagation();
          },
          { passive: false }
        );
      }

      // 添加标记
      const marker = new window.AMap.Marker({
        // icon:
        //   "https://a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
        position: [120.3740551, 30.3038754], // 设置标记的位置
      });

      //      // 创建信息窗口内容
      //       const infoContent = `
      //   <div style="padding: 10px;">
      //     <h3 style="color: #001C45;font-size: 16px;">杭州蓝昌科技有限公司</h3>
      //     <p style="margin-top:10px;color: #001C45CC;font-size: 14px;">电话: 133-477-09060</p>
      //     <p style="margin-top:10px;color: #001C45CC;font-size: 14px;">地址:浙江省杭州市钱塘区6号街260号正泰中自科技园10幢4层</p>
      //   </div>
      // `;

      //       // 创建信息窗口
      //       const infoWindow = new window.AMap.InfoWindow({
      //         content: infoContent,
      //         offset: new window.AMap.Pixel(10, 0), // 偏移量，使信息窗口出现在标记右侧
      //       });
      //       infoWindow.open(map, marker.getPosition());
      marker.setMap(map);
    },
    jump(type) {
      if (type == "1") {
        this.$router.push({ name: "aboutUs" });
      } else if (type == "2") {
        this.$router.push({ name: "products" });
      } else if (type == "3") {
        this.$router.push({ name: "aboutUs", query: { section: "qualifications" } });
      } else if (type == "4") {
        this.$router.push({ name: "aboutUs", query: { section: "partners" } });
      } else if (type == "5") {
        this.$router.push({ name: "contactUs" });
      }
    },
    //路由跳转
    goToPage(page) {
      // this.titleName = page;
      this.currentIndex = page;
      // const target = document.getElementById(page);
      // if (target) {
      //   target.scrollIntoView({ behavior: "auto" });
      // }
      // this.$router.push({ name: page });
    },
    // 动态获取动画类名
    getAnimationClass(index) {
      if (this.currentIndex === index) {
        return ["animate__animated", this.animations[index].enter];
      }
      return "";
    },

    async handleWheel(e) {
      if (this.isAnimating) return;
      e.preventDefault();

      const direction = e.deltaY > 0 ? "down" : "up";
      let newIndex = direction === "down" ? this.currentIndex + 1 : this.currentIndex - 1;

      if (newIndex < 0 || newIndex > 5) return;

      this.isAnimating = true;
      const oldIndex = this.currentIndex;
      this.currentIndex = newIndex; // 立即更新当前索引
      // 获取旧元素并添加退出动画
      const oldDiv = this.$refs[`div${oldIndex}`];
      const exitAnim = this.animations[oldIndex].exit;

      // 添加退出动画和高层级
      oldDiv.classList.add("animate__animated", exitAnim, "exiting");

      await new Promise((resolve) => {
        oldDiv.addEventListener(
          "animationend",
          () => {
            oldDiv.classList.remove("animate__animated", exitAnim, "exiting");
            resolve();
          },
          { once: true }
        );
      });
      this.isAnimating = false;
    },
    copyToClipboard(text) {
      // 创建一个临时的textarea元素
      const textarea = document.createElement("textarea");
      textarea.value = text;
      document.body.appendChild(textarea);

      // 选择文本
      textarea.select();
      textarea.setSelectionRange(0, 99999); // For mobile devices

      // 执行复制操作
      document.execCommand("copy");

      // 删除临时textarea
      document.body.removeChild(textarea);

      // 提示用户已复制
      alert("已复制: " + text);
    },
    getDetail(id) {
      const product = this.productDetail.find((item) => item.id === id);
      if (product) {
        this.Flag = true;
        this.poduct = product;
        // this.$router.push({
        //   name: "productDetail",
        //   query: { id: product.id },
        // });
      }
    },
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;
  background: #000;
}

.slider {
  width: 100%;
  will-change: transform;
}

.img_box {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: cover; /* 确保背景图覆盖整个容器 */
  background-position: center;
}

.img_box {
  z-index: 0;
}

.img_box.exiting {
  z-index: 2;
}
/* 自定义动画持续时间 */
.animate__animated {
  --animate-duration: 1s;
}
.tabMenu {
  width: 100%;
  height: 3.75vw;
  position: fixed;
  top: 0;
  z-index: 100;
  display: flex;
  justify-content: space-between;
}
.tabMenu .menuLeft {
  display: flex;
  flex: 1;
  align-items: center;
  margin-left: 10.167vw;
  /* justify-content: right;  */
  padding-right: 10.167vw; /* 调整右侧间距 */
}
.tabMenu .menuLeft img {
  width: 1.667vw;
  height: 1.667vw;
  /* width: 15.26vw;
  height: 2.604vw; */
  margin-right: 0.521vw; /* 调整图片与文字之间的间距 */
}
.tabMenu .menuLeft span {
  font-family: "FangSong", "仿宋", serif;
  font-size: 1.146vw;
  color: #fff;
}
.tabMenu .menuright {
  flex: 1;
  height: 100%;
  /* padding-left: 7.813vw; */
  display: flex; /* 修改为 flex 布局 */
  align-items: center; /* 垂直居中对齐 */
  /* background: #ccc; */
}
.menuItem {
  height: 100%;
  line-height: 3.75vw;
  padding: 0 0.313vw;
  color: #ffffffb2;
  font-family: Source Han Sans;
  font-weight: regular;
  font-size: 0.833vw;
  cursor: pointer;
  position: relative;
}

.menuItem:hover::after {
  content: "";
  position: absolute;
  bottom: 0.521vw;
  left: 0;
  width: 100%;
  height: 0.156vw;
  background-color: #87ceeb; /* 淡蓝色 */
  transition: opacity 0.3s ease;
  opacity: 1;
}

.menuItem::after {
  content: "";
  position: absolute;
  bottom: 0.521vw;
  left: 0;
  width: 100%;
  height: 0.156vw;
  background-color: #87ceeb; /* 淡蓝色 */
  opacity: 0;
  transition: opacity 0.3s ease;
}
.actiev {
  color: #fff !important;
  font-weight: bold !important;
}
.menuItem_img {
  width: 1.458vw;
  height: 1.458vw;
  border-radius: 0.208vw;
  background: rgba(255, 255, 255, 0.16);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 0.938vw;
  cursor: pointer;
}
.div0_mid {
  width: 40.469vw;
  height: 16.438vw;
  /* border: 0.417vw solid #FFFFFF3F; */
  border-radius: 0.313vw;
  position: relative;
  border-left: 0.417vw solid #ffffff3f;
  border-right: 0.417vw solid #ffffff3f;
  border-bottom: 0.417vw solid #ffffff3f;
}
.div0_mid:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 10.417vw;
  height: 0.417vw;
  background-color: #ffffff3f;
}
.div0_mid:after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 10.417vw; /* 下边框的点 */
  height: 0.417vw;
  background-color: #ffffff3f;
}
.mid_imgBox {
  position: absolute;
  width: 17.083vw;
  height: 3.906vw;
  top: 0;
  left: 50.5%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
}
.mid_imgBox img {
  width: 100%;
  height: 100%;
}
.englishLan {
  width: 100%;
  text-align: center;
  margin-top: 3.125vw;
}
.englishLan span {
  color: #ffffff;
  font-size: 1.458vw;
  letter-spacing: 0.156vw;
  font-weight: bolder;
  font-style: italic;
}

.englishLan span:not(:first-child) {
  padding-left: 1.042vw;
}
.div0_content {
  width: 100%;
  text-align: center;
  margin-top: 2.042vw;
  color: #ffffffd9;
  font-size: 0.938vw;
  font-weight: 200;
}
.div0_button_box {
  width: 100%;
  text-align: center;
  margin-top: 2.083vw;
  display: flex;
  justify-content: center; /* 水平居中 */
}

.div0_button {
  width: 5.208vw;
  height: 1.563vw;
  line-height: 1.563vw;
  text-align: center;
  background: rgb(39, 125, 255);
  color: #fff;
  border-radius: 0.104vw;
  font-size: 0.729vw;
  padding: 0 0.104vw;
  cursor: pointer;
  transition: transform 0.3s ease; /* 添加平滑过渡效果 */
}

.div0_button:hover {
  transform: scale(1.1); /* 鼠标移入时放大 */
}
.xiala {
  width: 5.729vw;
  height: 3.542vw;
  position: absolute;
  top: 15%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
}
.footer {
  position: fixed;
  left: 4.167vw;
  bottom: 10px;
  z-index: 10000;
  color: #ffffff;
  font-family: Source Han Sans;
  font-weight: regular;
  font-size: 0.625vw;
  line-height: 0.625vw;
  letter-spacing: 0vw;
  text-align: left;
}
.xiala img {
  width: 2.083vw;
  height: 2.083vw;
  display: block;
  margin: 0 auto;
  animation: upDown 1.5s ease-in-out infinite;
}

@keyframes upDown {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-0.26vw);
  }
}
.xiala_line {
  width: 100%;
  color: #ffffff;
  font-family: Source Han Sans;
  font-weight: medium;
  font-size: 0.729vw;
  line-height: 0.833vw;
  letter-spacing: 0.104vw;
  text-align: center;
  margin-top: 0.521vw;
}
.div1_mid {
  width: 43.073vw;
  /* margin-top: 200px; */
  margin-right: 17.042vw !important;
}
.div8_mid {
  width: 43.073vw;
  margin-top: -20.833vw;
  height: 13.542vw;
  /* border: 1px solid red; */
  margin-right: 17.042vw !important;
}
.titleBox {
  width: 9.271vw;
  height: 3.646vw;
  position: relative;
  padding-left: 1.042vw;
}
.titleBox:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 0.833vw;
  height: 3.646vw;
  background: linear-gradient(180deg, #27c2ff00 0%, #27c2ff 78%);
}
.titleBox::after {
  content: "";
  position: absolute;
  top: -0.521vw;
  right: -1.042vw;
  width: 1.667vw;
  height: 1.302vw;
  background-image: url("../assets/star.png");
  background-size: cover;
  background-repeat: no-repeat;
}
.titleBox_chinese {
  color: #ffffff;
  font-family: Douyin Sans;
  font-weight: bold;
  font-size: 2.083vw;
  line-height: 2.083vw;
  letter-spacing: 0vw;
  text-align: left;
}
.titleBox_english {
  color: #b6daff;
  font-family: Source Han Sans CN;
  font-weight: regular;
  font-size: 0.938vw;
  line-height: 1.042vw;
  letter-spacing: 0vw;
  text-align: left;
  margin-top: 0.521vw;
}

.titleBox_english span:not(:first-child) {
  padding-left: 0.521vw;
}
.div1_midc_content {
  width: 100%;
  margin-top: 1.25vw;
}
.div1_midc_content span {
  color: #d3e9ff;
  font-family: Source Han Sans CN;
  font-weight: regular;
  font-size: 1.042vw;
  line-height: 1.667vw;
  letter-spacing: 0vw;
  text-align: justified;
  font-weight: 200;
}
.blod {
  color: #fff !important;
  font-weight: bold !important;
}
.div1_button_box {
  margin-top: 3.125vw;
}
.div1_button {
  width: 5.579vw;
  height: 2.188vw;
  border-radius: 1.094vw;
  background: #277dff;
  text-align: center;
  line-height: 2.188vw;
  color: #ffffff;
  font-family: Source Han Sans CN;
  font-weight: medium;
  font-size: 0.738vw;
  position: relative;
  padding-right: 1.042vw; /* 添加右内边距，向左调整文字位置 */
  transition: transform 0.3s ease;
  cursor: pointer;
}
.div1_button:hover {
  transform: scale(1.1); /* 鼠标移入时放大 */
}
.div1_button::after {
  content: "";
  position: absolute;
  top: 0.729vw;
  right: 1.198vw;
  width: 0.833vw;
  height: 0.833vw;
  background-image: url("../assets/toRight.png");
  background-size: cover;
  background-repeat: no-repeat;
}
.div2_mid {
  height: 18.542vw;
  width: 57.292vw;
  margin-right: 2.042vw !important;
  margin-top: -8.125vw;
  display: flex;
  position: relative;
}
.div2_left {
  width: 28.75vw;
  height: 18.542vw;
}
.div2_right {
  width: 28.542vw;
  height: 18.854vw;
}
.div2_right img {
  width: 100%;
  height: 90%;
  margin-top: -2.083vw;
}
.div4_mid {
  width: 43.073vw;
  height: 26.684vw;
  margin-right: 17.042vw !important;
  /* border: 0.052vw solid #ffffff3f; */
}
.div4_mid_content {
  color: #d3e9ff;
  font-family: Source Han Sans CN;
  font-weight: regular;
  font-size: 1.042vw;
  line-height: 1.667vw;
  letter-spacing: 0vw;
  text-align: justified;
  margin-top: 1.25vw;
  font-weight: 300;
}
.div4_mid_ul {
  list-style: none;
  margin-top: 1.354vw;
}
.div4_mid_ul li {
  margin-top: 1.042vw;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.div4_mid_ul li img {
  width: 1.25vw;
  height: 1.25vw;
  margin-right: 0.625vw;
}
.div4_mid_ul li span {
  display: inline-block;
  vertical-align: middle;
  color: #ffffff;
  font-family: Source Han Sans CN;
  font-weight: medium;
  font-size: 1.042vw;
}
.div4_mid_img {
  margin-top: 1.354vw;
  display: flex;
}
.pai_image img {
  width: 7.002vw;
  height: 5.434vw;
}

.pai_image:not(:first-child) {
  margin-left: 0.729vw;
}
.div5_mid {
  width: 37.823vw;
  height: 10.208vw;
  margin-top: -15.229vw;
}
.contact_one {
  width: 100%;
  color: #ffffff;
  font-family: Douyin Sans;
  font-weight: bold;
  font-size: 2.083vw;
  line-height: 2.083vw;
  letter-spacing: 0vw;
  text-align: center;
}
.contact_two {
  width: 100%;
  color: #b6daff;
  font-family: Source Han Sans CN;
  font-weight: 200;
  font-size: 1.042vw;
  line-height: 1.042vw;
  margin-top: 0.521vw;
  letter-spacing: 0vw;
  text-align: center;
}
.contact_three {
  width: 100%;
  display: flex;
  margin-top: 1.354vw;
  justify-content: center;
}
.contact_three_item {
  color: #b6daff;
  font-family: Source Han Sans CN;
  font-weight: regular;
  font-size: 1.042vw;
  line-height: 1.042vw;
  letter-spacing: 0vw;
  display: flex;
  align-items: center; /* 垂直居中对齐 */
  margin-left: 2.083vw; /* 第二个div离第一个左边距2.083vw */
}
.contact_three_item:first-child {
  margin-left: 0; /* 确保第一个div没有左边距 */
}

.contact_three_item img {
  margin-right: 0.321vw; /* 调整图片与文字之间的间距 */
}
.button5 {
  margin-top: 1.979vw !important;
  display: flex;
  justify-content: center; /* 水平居中 */
}
.productBox {
  width: 55.469vw;
  height: 8.854vw;
  position: absolute;
  bottom: -5.729vw;
  overflow: hidden;
  /* 隐藏滚动条 */
}
.productBox_item:not(:first-child) {
  margin-left: 0.521vw;
}
.imgBox {
  display: flex;
  white-space: nowrap;
  animation: product-scroll 50s linear infinite;
}

.imgBox:hover {
  animation-play-state: paused;
}

.productBox_item {
  margin-left: 0.521vw;
  cursor: pointer;
}

/* 关键帧动画：向左滚动 */
@keyframes product-scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-180%);
  }
}
.productBox_item img {
  width: 10.417vw;
  height: 6.25vw;
}
.productBox_item p {
  color: #b6daff;
  margin-top: 0.781vw;
  font-size: 0.833vw;
}
.imgDataBox {
  margin-top: 2.604vw;
}
.imgDataBox img {
  width: 62.5vw;
  margin-left: -9.417vw;
}
.product_img {
  max-width: 30.083vw;
  max-height: 26.042vw;
  /* height: 26.042vw; */
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.product_detail_box {
  display: flex;
}
.product_content {
  font-size: 0.833vw;
  margin-top: 1.042vw;
  color: #b6daff;
  margin-left: 1.563vw;
}
.img_titleBox {
  display: flex;
  align-items: center; /* 让图片和 span 垂直居中 */
  justify-content: center; /* 让图片水平居中 */
  margin-top: 1.979vw;
}

.img_titleBox img {
  height: auto;
  max-width: 10.417vw; /* 可以根据需要调整图片的大小 */
}

.fangkuai {
  display: inline-block;
  height: 8px;
  width: 8px;
  background-color: rgb(89, 154, 222);
  margin: 0 10px; /* 可以调整间距 */
}
.partner_list {
  width: 100%;
  /* height: 8.542vw; */
  /* background: #f8fafc; */
  margin-top: 2.604vw;
  display: flex;
  justify-content: flex-start;
}

.partner_title {
  flex: 1;
  color: #b6daff;
  font-family: Source Han Sans;
  font-weight: medium;
  font-size: 1.05vw;
  line-height: 3.542vw;
  letter-spacing: 0vw;
  text-align: center;
}
.partner_img {
  flex: 4.5;
  display: flex;
  justify-content: space-around; /* 水平均匀排列 */
  align-items: center; /* 垂直居中 */
}
.partner_img img {
  width: 5.375vw;
  height: 5.375vw;
}
.partner_img_box {
  background-color: #fff;
  padding: 10px;
}
.mapBox {
  margin-top: 30px;
  width: 100%;
  height: 16.875vw;
  border-radius: 10px;

  /* border: 1px solid red; */
}
</style>


// WEBPACK FOOTER //
// src/pages/home.vue